import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import Heading from "atoms/Heading";
import Text from "atoms/Text";
import Button from "atoms/Button";
import CheckBox from "atoms/CheckBox";
import OtpComponent from "../molecules/OtpComponent";
import { Controller } from "react-hook-form";
import { getFeatureFlags } from "lib/utils";
import Card from "atoms/Card";
import { otpResendTimeInSec, otpLength } from "../constants";

const OtpScreen = ({
  handleLogin,
  loginDetails,
  resendOtp,
  error,
  errorStatus,
  control,
  setValue,
  isAdmin,
}) => {
  const flag = getFeatureFlags();
  const [otp, setOtp] = useState("");
  const isRateLimitError = errorStatus === 429;
  //timer logic
  const [timer, setTimer] = useState(otpResendTimeInSec);
  const timeOutCallback = useCallback(
    () => setTimer((currTimer) => currTimer - 1),
    []
  );
  useEffect(() => {
    let timeoutId;
    if (timer > 0) {
      timeoutId = setTimeout(timeOutCallback, 1000);
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [timer, timeOutCallback]);

  const resetTimer = function () {
    if (!timer) {
      setTimer(otpResendTimeInSec);
    }
  };

  //events
  const onClickLogin = (event) => {
    event.preventDefault();
    handleLogin(otp);
  };
  const handleResendOtp = () => {
    resetTimer();
    resendOtp();
  };
  return (
    <Card
      cardClass="p-6 shadow-lg absolute top-[150px] left-1/2 transform -translate-x-1/2 translate-x-[98px] opacity-100 rounded-[39.29px] flex flex-col items-center"
      cardBg="bg-oneConnectBg"
      cardWidth="w-[360px]"
      cardHeight="h-[390px]"
    >
      <Heading
        type="h2"
        className="text-brandGreen flex items-center justify-center gap-2"
      >
        <img
          src="/images/1CLogo.svg"
          alt="1C Logo"
          className="h-14 w-auto mix-blend-multiply"
        />
        <span className="font-black">1 Connect</span>
      </Heading>
      <Text className="font-schibsted text-[18px] leading-[100%] tracking-normal align-middle text-oneConnectBlue text-center mt-6">
        Enter verification code
      </Text>
      <form
        onSubmit={onClickLogin}
        className="mt-6 w-full flex flex-col items-center"
      >
        <div className="mb-4 w-[300px] mx-auto">
          <Text className="text-center text-[12px] tracking-wide font-poppins text-oneConnectBlue">
            {timer === 0 && !isRateLimitError ? (
              <>
                Didn't get the OTP? Please check if your{" "}
                {loginDetails.loginType === "email"
                  ? "email address"
                  : "mobile number"}
                <br />
                <span className="font-semibold break-all inline-block max-w-full">
                  {loginDetails.loginType === "email"
                    ? loginDetails.emailId
                    : loginDetails.mobileNumber}
                </span>{" "}
                is correct.
              </>
            ) : (
              <>
                If the provided{" "}
                <span className="font-semibold ml-1 tracking-normal">
                  {loginDetails.loginType === "email"
                    ? "email address"
                    : "mobile number"}
                </span>
                &nbsp; is registered with us, you will receive an{" "}
                <span className="font-semibold ml-1 tracking-normal">
                  {loginDetails.loginType === "email" ? "email" : "SMS"}
                </span>
                &nbsp; with an OTP.
              </>
            )}
          </Text>
        </div>
        <div className="w-[242px]">
          <div className="flex justify-center">
            <OtpComponent
              onChange={setOtp}
              otpValue={otp}
              length={otpLength}
              errorMessage={isRateLimitError ? "" : error}
            />
          </div>
          {isRateLimitError && (
            <Text className="my-4 text-center text-sm text-error font-light">
              {error}
            </Text>
          )}
          {timer > 0 && !isRateLimitError && (
            <Text className="my-4 text-center text-sm text-gray-600 font-light text-oneConnectBlue">
              Resend OTP in{" "}
              <span className="text-gray-900 font-bold text-oneConnectBlue">
                {timer}s
              </span>
            </Text>
          )}
          <Button
            type="submit"
            variant="brandGreenBtn"
            fontWeight="font-bold"
            btnClass="w-[242px] h-12 mt-4"
            disabled={otp.length != otpLength}
          >
            Login
          </Button>
          {timer === 0 && !isRateLimitError && (
            <div onClick={handleResendOtp}>
              <Text className="w-full mt-5 text-center font-schibsted text-[13px] leading-[100%] tracking-wider align-middle underline text-oneConnectBlue">
                Send the code again
              </Text>
            </div>
          )}
          {!loginDetails.whatsappConsent &&
            flag?.whatsapp_consent?.enabled &&
            !isAdmin && (
              <div className="my-5">
                <Controller
                  control={control}
                  name={`whatsappConsent`}
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <CheckBox
                      name="whatsappConsent"
                      checkBoxLabel="Send Notification via Whatsapp"
                      isSelected={value}
                      value={value}
                      onChange={(e) => {
                        setValue("whatsappConsent", e.target.checked);
                      }}
                    />
                  )}
                />
              </div>
            )}
        </div>
      </form>
    </Card>
  );
};
export default OtpScreen;

OtpScreen.propTypes = {
  loginDetails: PropTypes.object,
  error: PropTypes.string,
  errorStatus: PropTypes.number,
  handleLogin: PropTypes.func,
  resendOtp: PropTypes.func,
};
